import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogIsCatalogOnly,
    getCatalogIsTimedPlusBiddingOpen,
    getCatalogStartTime,
    getCatalogStatus,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import {
    getRegistrationApproved,
    getRegistrationApprovedWithLimit,
    getRegistrationDeclined,
    getRegistrationPending,
} from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import { shouldShowLive } from '@/utils/live';

export enum CatalogStatus {
    PendingCatalogOnly,
    Pending,
    Approved,
    Declined,
    Live,
}

const useGetCatalogStatus = (catalogId: number, forceIsLive: boolean): CatalogStatus => {
    const approved = useAppSelector((state) => getRegistrationApproved(state, catalogId));
    const limited = useAppSelector((state) => getRegistrationApprovedWithLimit(state, catalogId));
    const pending = useAppSelector((state) => getRegistrationPending(state, catalogId));
    const saleStartTs = useAppSelector((state) => getCatalogStartTime(state, catalogId));
    const catalogStatus = useAppSelector((state) => getCatalogStatus(state, catalogId));
    const declined = useAppSelector((state) => getRegistrationDeclined(state, catalogId));
    const isCatalogOnly = useAppSelector((state) => getCatalogIsCatalogOnly(state, catalogId));
    const isTimedPlusOpen = useAppSelector((state) => getCatalogIsTimedPlusBiddingOpen(state, catalogId));

    const isLive = forceIsLive || isTimedPlusOpen || shouldShowLive(catalogStatus, isCatalogOnly, saleStartTs);

    let currentCatalogStatus: CatalogStatus;

    if (isCatalogOnly) {
        currentCatalogStatus = CatalogStatus.PendingCatalogOnly;
    } else if (declined) {
        currentCatalogStatus = CatalogStatus.Declined;
    } else if (pending) {
        currentCatalogStatus = CatalogStatus.Pending;
    } else if (approved) {
        currentCatalogStatus = CatalogStatus.Approved;
    } else if (limited) {
        currentCatalogStatus = CatalogStatus.Approved;
    }

    return isLive ? CatalogStatus.Live : currentCatalogStatus;
};

export default useGetCatalogStatus;
